import React from 'react'
import { Box } from '@mui/material'
import logoSvg from '../../assets/images/logo.svg'
import LoginButton from '../../components/button/login-button'

const HomePage: React.FC = () => {
  return (
    <Box sx={{
      width: 1,
      height: 1,

      /* https://www.joshwcomeau.com/gradient-generator?colors=1b161e|352a3a|44394a|53435b|665270&angle=45&colorMode=hsl&precision=5&easingCurve=0.333|1|0.666|0 */
      backgroundImage: `linear-gradient(
      45deg,
      hsl(278deg 15% 10%) 0%,
      hsl(278deg 15% 14%) 21%,
      hsl(280deg 16% 19%) 30%,
      hsl(281deg 15% 22%) 39%,
      hsl(279deg 14% 25%) 46%,
      hsl(278deg 14% 27%) 54%,
      hsl(280deg 14% 29%) 61%,
      hsl(280deg 15% 32%) 69%,
      hsl(281deg 16% 35%) 79%,
      hsl(280deg 15% 38%) 100%
      )`,
    }}>
      <Box
        sx={{
          /* From https://css.glass */
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '16px',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(5px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',

          /* Center */
          width: 'fit-content',
          margin: 'auto',
          position: 'relative',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        <Box sx={{ margin: 4 }}>
          <img src={logoSvg} alt='Logo' style={{ height: '128px' }}/>
        </Box>
        <Box sx={{ margin: 2, textAlign: 'center' }}>
          <LoginButton/>
        </Box>
      </Box>
    </Box>
  )
}

export default HomePage
